
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/education-quiz-intro",
      function () {
        return require("private-next-pages/education-quiz-intro.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/education-quiz-intro"])
      });
    }
  